<template>
  <ion-content id="app" class="ion-padding">

    <a :href="['/#/box/list/']">Zurück</a>

    <h1>{{ editBox.title }}</h1>

    <a :href="['/#/link/new/' + box + '/']">Neuen Link erstellen</a>

    <ion-list>
      <ion-item v-for="link in allLinks" :key="link.id">
        <ion-label>{{ link.title }}</ion-label>
        <ion-icon name="trash" @click="runDeleteLink(link)"/>

        <a :href="['/#/link/edit/' + box + '/' + link.id + '/']">
          <ion-icon name="build"></ion-icon>
        </a>
      </ion-item>
    </ion-list>

  </ion-content>
</template>

<script>

  import {mapActions, mapGetters} from "vuex";


  export default {
    name: "LinkList",
    data(){
      return {
        box: this.$route.params.box
      }
    },
    methods: {
      ...mapActions([ "getLinks", "getBox", "deleteLink" ]),
      runDeleteLink(link) {
        this.deleteLink(link);
      }
    },
    computed: mapGetters(["allLinks", "editBox"]),
    created() {
      this.getLinks(this.box);
      this.getBox(this.box);
    }
  };
</script>

<style scoped>
  ion-icon {
    margin-left: 20px;
  }

  ion-list {
    --background: #3E4143;
    padding: 0;
    margin-top: 40px;
  }
</style>
